import { Component, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { WebhookSubscription, ClientWebhookSubscription, StoreWebhookSubscription } from '../../../shared/models/webhook.model';

export interface TableColumn {
  header: string;
  field: string;
  icon?: string;
  muted?: boolean;
  badge?: boolean;
  isDate?: boolean;
  successValue?: string;
}

export type DataTableItem = WebhookSubscription | ClientWebhookSubscription | StoreWebhookSubscription;

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent {
  @Input() data: DataTableItem[] = [];
  @Input() columns: TableColumn[] = [];
  @Input() isLoading: boolean = false;
  @Input() emptyMessage: string = 'No data available.';
  @Input() showActions: boolean = false;
  @Input() showEditButton: boolean = false;
  @Input() showToggleButton: boolean = false;
  @Input() showDeleteButton: boolean = false;
  @Input() isTogglingId: number | string | null = null;
  @Input() stateField: string = 'state';
  @Input() successStateValue: string = 'ACTIVE';
  @Input() actionsTemplate: TemplateRef<any> | null = null;

  @Output() onEdit = new EventEmitter<DataTableItem>();
  @Output() onToggle = new EventEmitter<DataTableItem>();
  @Output() onDelete = new EventEmitter<DataTableItem>();
}
